export const isAuthBootstrapPending = ({ authBootstrapResolved, currentUser }) =>
  !authBootstrapResolved && currentUser === null;

// An MFA challenge can leave this marker behind after the challenge is
// abandoned. It is safe to clear only after Cognito has confirmed a valid
// authenticated session; it must never be used to sign out that session.
export const clearIncompleteMfaState = (storage) => {
  if (storage && typeof storage.removeItem === "function") {
    storage.removeItem("mfaState");
  }
};
